module.exports = __webpack_public_path__ + "img/first-en.48c1e7fd.png";